export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "germantown",
    name: "Germantown",
    state: "TN",
    region: "Shelby County",
    isPrimary: true,
    lat: 35.0868,
    lng: -89.8101,
    description:
      "MGL Cleaning Solutions is based in Germantown, TN. We clean homes and offices throughout Germantown and the surrounding Memphis suburbs, Monday through Friday, 8 AM to 5 PM.",
    highlights: [
      "Locally owned and based in Germantown, TN",
      "Deep, regular, move-in/out & one-time cleaning",
      "Weekday service, 8 AM – 5 PM",
      "Free, no-pressure estimates",
    ],
    content: [
      "Germantown is home base for MGL Cleaning Solutions. We know these neighborhoods — from Farmington and Forest Hill Irene to the homes along Poplar and the offices near Germantown Parkway. Every visit comes with our own products, our own equipment, and a checklist built around your space.",
      "Germantown homeowners book us for recurring weekly and bi-weekly cleaning, seasonal deep cleans, and move-in / move-out turnovers. Local offices and small businesses rely on us to keep their workspace presentable for staff and clients alike.",
      "Call (901) 864-4659 for a free, no-pressure cleaning estimate in Germantown today.",
    ],
    cities: [
      { name: "Forest Hill Irene", lat: 35.073, lng: -89.783 },
      { name: "Farmington", lat: 35.093, lng: -89.804 },
      { name: "Collierville", lat: 35.042, lng: -89.6645 },
      { name: "Cordova", lat: 35.1565, lng: -89.7737 },
    ],
  },
  {
    slug: "collierville",
    name: "Collierville",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.0420,
    lng: -89.6645,
    description:
      "Professional house and office cleaning in Collierville, TN. Deep cleaning, recurring service, move-in / move-out, and one-time cleans with weekday scheduling.",
    highlights: [
      "Recurring & one-time house cleaning",
      "Move-in / move-out turnovers",
      "Office & small business cleaning",
      "Free written estimates",
    ],
    content: [
      "Collierville families choose MGL Cleaning Solutions for dependable, detail-focused cleaning. Whether it's a large home near the Town Square or a newer build off Houston Levee, we bring the same consistent checklist to every visit.",
      "We handle recurring weekly and bi-weekly service, seasonal deep cleans, and move-in / move-out cleaning for renters, sellers, and property managers throughout Collierville.",
      "Call (901) 864-4659 to book a free cleaning estimate in Collierville.",
    ],
    cities: [
      { name: "Town Square", lat: 35.042, lng: -89.664 },
      { name: "Houston Levee", lat: 35.075, lng: -89.707 },
      { name: "Piperton", lat: 35.043, lng: -89.632 },
    ],
  },
  {
    slug: "cordova",
    name: "Cordova",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.1565,
    lng: -89.7737,
    description:
      "Cordova, TN cleaning services. Recurring house cleaning, deep cleans, move-in / move-out, and office cleaning for homes and businesses across Cordova.",
    highlights: [
      "Weekly, bi-weekly & monthly plans",
      "Deep cleaning & one-time visits",
      "Apartment & townhome cleaning",
      "Office & workspace cleaning",
    ],
    content: [
      "Cordova is one of our busiest service areas. We clean single-family homes, townhomes, and apartments across the neighborhoods off Germantown Parkway, Macon, and Walnut Grove.",
      "Recurring Cordova customers appreciate the consistency — the same checklist, the same standard, every visit. One-time deep cleans and move-out cleans are available on short notice most weeks.",
      "Reach us at (901) 864-4659 for your free Cordova cleaning estimate.",
    ],
    cities: [
      { name: "Countrywood", lat: 35.176, lng: -89.749 },
      { name: "Berryhill", lat: 35.166, lng: -89.79 },
      { name: "Bartlett", lat: 35.2045, lng: -89.8739 },
    ],
  },
  {
    slug: "bartlett",
    name: "Bartlett",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.2045,
    lng: -89.8739,
    description:
      "Bartlett, TN house and office cleaning. Deep cleaning, recurring maintenance, move-in / move-out, and one-time cleans with honest, upfront pricing.",
    highlights: [
      "House cleaning on your schedule",
      "Move-in & move-out cleans",
      "One-time deep cleans available",
      "Small business & office cleaning",
    ],
    content: [
      "Bartlett homes and small businesses trust MGL Cleaning Solutions for straightforward, reliable cleaning. From established neighborhoods off Stage Road to newer builds near Elmore Park, we treat every home like it's our own.",
      "We offer flexible weekday scheduling and one-time deep cleans for moves, holidays, and special occasions — plus recurring plans for households that want it handled year-round.",
      "Call (901) 864-4659 for a free Bartlett cleaning estimate.",
    ],
    cities: [
      { name: "Elmore Park", lat: 35.219, lng: -89.874 },
      { name: "Stage Road", lat: 35.229, lng: -89.85 },
      { name: "Ellendale", lat: 35.229, lng: -89.822 },
    ],
  },
  {
    slug: "eads",
    name: "Eads",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.1665,
    lng: -89.6570,
    description:
      "Cleaning services in Eads, TN. House cleaning, deep cleaning, and move-in / move-out service for homes and properties across east Shelby County.",
    highlights: [
      "Large & rural property cleaning",
      "Deep cleaning specialists",
      "Move-in / move-out turnovers",
      "Free, no-pressure estimates",
    ],
    content: [
      "Eads sits on the eastern edge of our service area, and we're out there every week. Larger lots and larger homes need a team that plans the work properly — and that's exactly how we approach every Eads job.",
      "Deep cleans, recurring maintenance, and move-in / move-out turnovers are all available. We bring our own supplies and equipment to every visit.",
      "Book your free Eads cleaning estimate at (901) 864-4659.",
    ],
    cities: [
      { name: "Fisherville", lat: 35.176, lng: -89.618 },
      { name: "Collierville", lat: 35.042, lng: -89.6645 },
      { name: "Cordova", lat: 35.1565, lng: -89.7737 },
    ],
  },
  {
    slug: "east-memphis",
    name: "East Memphis",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.1174,
    lng: -89.8878,
    description:
      "East Memphis cleaning services. Recurring house cleaning, deep cleans, and office cleaning for homes, condos, and workspaces across East Memphis.",
    highlights: [
      "House, condo & apartment cleaning",
      "Office & professional suite cleaning",
      "Recurring and one-time service",
      "Deep cleaning & move-out cleans",
    ],
    content: [
      "East Memphis is a mix of established homes, condos, and busy professional offices — and we clean all three. From the neighborhoods around Poplar and Ridgeway to the office suites nearby, our team keeps spaces consistently presentable.",
      "Office clients book us on recurring weekly or bi-weekly plans. Homeowners book everything from a single deep clean to year-round maintenance.",
      "Get your free East Memphis cleaning quote at (901) 864-4659.",
    ],
    cities: [
      { name: "Poplar Corridor", lat: 35.115, lng: -89.87 },
      { name: "Ridgeway", lat: 35.096, lng: -89.85 },
      { name: "White Station", lat: 35.122, lng: -89.9 },
    ],
  },
  {
    slug: "memphis",
    name: "Memphis",
    state: "TN",
    region: "Shelby County",
    isPrimary: false,
    lat: 35.1495,
    lng: -90.0490,
    description:
      "Memphis, TN cleaning company. House cleaning, deep cleaning, move-in / move-out, one-time cleans, and office cleaning across the city.",
    highlights: [
      "Residential & office cleaning",
      "Deep cleaning & one-time visits",
      "Move-in / move-out turnovers",
      "Honest, upfront pricing",
    ],
    content: [
      "Memphis is a big city with a lot of different kinds of spaces, and we clean across it — houses, apartments, condos, and small offices alike. Our team brings the same standard downtown that we bring to the suburbs.",
      "Whether you need a one-time deep clean before guests arrive or a recurring plan that keeps things handled all year, we'll build the checklist around your space and your budget.",
      "Call (901) 864-4659 for a free Memphis cleaning estimate.",
    ],
    cities: [
      { name: "Downtown", lat: 35.146, lng: -90.049 },
      { name: "Midtown", lat: 35.135, lng: -89.99 },
      { name: "East Memphis", lat: 35.1174, lng: -89.8878 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
